<script setup lang="ts"></script>

<template>
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_231_10319)">
            <path
                d="M8.75 5.625C8.75 2.51953 11.2695 0 14.375 0C15.1172 0 15.8242 0.144531 16.4727 0.402344L13.125 3.75V6.875H16.25L19.5977 3.52734C19.8555 4.17578 20 4.88281 20 5.625C20 8.01953 18.5039 10.0664 16.3945 10.875L14.6328 9.11328L13.75 8.23047L12.8672 9.11328L12.5391 9.44141L8.75 5.65234V5.62109V5.625ZM0 16.25L6.57812 9.67188L9.44531 12.5391L9.11719 12.8672L8.23047 13.75L9.11328 14.6328L3.75 20L0 16.25ZM5.38672 15.9375L4.0625 14.6133L2.73828 15.9375L4.0625 17.2617L5.38672 15.9375ZM11.2109 12.5391L6.17188 7.5H3.75L0 2.5L2.5 0L7.5 3.75V6.17578L12.5391 11.2109L13.75 10L20 16.25L16.25 20L10 13.75L11.2109 12.5391Z"
                fill="white"
            />
        </g>

        <defs>
            <clipPath id="clip0_231_10319">
                <rect
                    width="20"
                    height="20"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
</template>
